import { BetslipError } from '../betslip-error';
import { NotifyUserErrorMixin } from '../notify-user-error';
import { PreCheckErrorMixin } from './pre-check-error';

/**
 * Error that indicates that current accept EP value does not match EP settings for the user.
 * for example ep value goes down and settings are accept higher.
 */
export class EditBetEarlyPayoutChangedPreCheckError extends PreCheckErrorMixin(NotifyUserErrorMixin<BetslipError>(BetslipError)) {
    constructor(
        public earlyPayoutValue: number,
        public acceptedEarlyPayoutValue: number,
    ) {
        super();
        this.isHidden = true;
    }

    override equals(error: BetslipError): boolean {
        return (
            error instanceof EditBetEarlyPayoutChangedPreCheckError &&
            error.earlyPayoutValue === this.earlyPayoutValue &&
            error.acceptedEarlyPayoutValue === this.acceptedEarlyPayoutValue
        );
    }
}
